import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material'
import CustomMediaCard from '../card/CustomImageCard'

interface TitleTypographyControllerProps {
  title: string
  value:
    | string
    | number
    | {
        attachmentType: string
        presignedUrl: string
        fileType: string
        fileName: string
      }[]
  required: boolean
}

function formatNumberWithComma(val: string | number | undefined) {
  if (val === undefined || val === null || val === '') return ''

  const num = typeof val === 'string' ? Number(val.replace(/,/g, '')) : val

  if (isNaN(num)) return val

  const decimals =
    typeof val === 'string' && val.includes('.') ? val.split('.')[1].length : 0

  return num.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals > 3 ? 3 : decimals,
  })
}

const TitleTypography = ({
  title,
  value,
  required,
}: TitleTypographyControllerProps) => {
  const renderValue = () => {
    if (
      title === 'Cost Amount' &&
      (typeof value === 'number' || typeof value === 'string')
    ) {
      return formatNumberWithComma(value)
    }
    if (typeof value === 'string' || typeof value === 'number') {
      return value
    }
    return ''
  }

  return (
    <Box>
      <Typography
        variant="caption"
        component="div"
        sx={{
          color: 'text.secondary',
          mb: 0.5,
          mt: 0,
          fontSize: 14,
        }}
      >
        {title ?? 'Default Title'}
        <Box
          component="span"
          sx={{
            color: 'red',
            fontSize: '0.75em',
            verticalAlign: 'super',
          }}
        >
          {required ? '*' : null}
        </Box>
      </Typography>

      {Array.isArray(value) ? (
        value.map((item, index) => (
          <div key={index}>
            <CustomMediaCard
              cardMaxHeight={{ xs: 50, sm: 50, md: 50 }}
              cardWidth={{ xs: 120, sm: 140, md: 160 }}
              src={item.presignedUrl}
              attachmentNumber={item.fileName}
              attachmentType={item.fileType}
              attachmentName={item.fileName}
              imageMaxHeight={25}
              cardMinHeight={50}
            />
          </div>
        ))
      ) : (
        <Typography
          variant="caption"
          component="div"
          sx={{
            color: 'text.primary',
            mb: 0.5,
            paddingLeft: 2,
            fontSize: 14,
          }}
        >
          {renderValue() ?? ''}
        </Typography>
      )}
    </Box>
  )
}

export default TitleTypography
